import { createContext } from 'react';

export const CreationFundInvestorTagContext = createContext(null);
